export const tenGodMandarin = {
  seven_killings: '七殺',
  direct_officer: '正官',
  indirect_resource: '偏印',
  direct_resource: '正印',
  friend: '比肩',
  eating_god: '食神',
  rob_wealth: '劫財',
  hurting_officer: '傷官',
  direct_wealth: '正財',
  indirect_wealth: '偏財',
}

export default {
  seven_killings: 'SK',
  direct_officer: 'DO',
  indirect_resource: 'IR',
  direct_resource: 'DR',
  friend: 'F',
  eating_god: 'EG',
  rob_wealth: 'RW',
  hurting_officer: 'HO',
  direct_wealth: 'DW',
  indirect_wealth: 'IW',
}
